import { AxiosError } from 'axios';
import { DefaultOtpType } from '../../api/user/model';
import { GET_USER_SETTINGS_URL } from '../../constants/apiUrls';
import { GET_USER_SETTINGS_QUERY_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
interface GetUserSettingsResponse {
  credentialType: string;
  otpType: DefaultOtpType;
}

interface Input {
  onSuccess?: (data: GetUserSettingsResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetUserSettings = ({ onSuccess, onError }: Input = {}) => {
  const getUserSettings = async () => {
    const res = await axiosClient.get<GetUserSettingsResponse>(GET_USER_SETTINGS_URL);

    return res.data;
  };

  return useCustomQuery(GET_USER_SETTINGS_QUERY_KEY, getUserSettings, {
    onSuccess,
    onError,
  });
};
